// src/utils/auth.js
export function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function isTokenExpired(token, skewSeconds = 10) {
  if (!token) return true;

  const payload = parseJwt(token);
  const exp = payload?.exp;
  if (!exp) return true;

  const now = Math.floor(Date.now() / 1000);
  return exp <= now + skewSeconds; // skew evita “na risca” dar erro
}
